var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flat-color-icons:collect"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.999349,
    y: 0.997396,
    width: 10,
    height: 10,
    stroke: "#F9FAFA",
    strokeWidth: 0.666667
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.55469 8.44531H6.44358V10.8898H5.55469V8.44531Z",
    fill: "#F9FAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M5.99891 7.24219L7.55447 9.10885H4.44336L5.99891 7.24219Z",
    fill: "#F9FAFA"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M5.55469 1.10938H6.44358V3.55382H5.55469V1.10938Z",
    fill: "#F9FAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M5.99891 4.75729L4.44336 2.89062H7.55447L5.99891 4.75729Z",
    fill: "#F9FAFA"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M1.11133 5.55469H3.55577V6.44358H1.11133V5.55469Z",
    fill: "#F9FAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M4.75534 6.00087L2.88867 7.55642V4.44531L4.75534 6.00087Z",
    fill: "#F9FAFA"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M8.44336 5.55469H10.8878V6.44358H8.44336V5.55469Z",
    fill: "#F9FAFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M7.24414 6.00087L9.11081 4.44531V7.55642L7.24414 6.00087Z",
    fill: "#F9FAFA"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M5.9987 6.66146C6.36689 6.66146 6.66536 6.36298 6.66536 5.99479C6.66536 5.6266 6.36689 5.32812 5.9987 5.32812C5.63051 5.32812 5.33203 5.6266 5.33203 5.99479C5.33203 6.36298 5.63051 6.66146 5.9987 6.66146Z",
    fill: "#F9FAFA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectWhite);
export default __webpack_public_path__ + "static/media/select-white.ca5fa4462f4cdfe98d30243a8e994561.svg";
export { ForwardRef as ReactComponent };